__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => (typeof console !== "undefined" && console.warn && console.warn(msg));
	var uniqueName = "@amzn/wfmtrainer-hub-mfe";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@amzn/katal-metrics-driver-sushi", "1.1.1", () => (Promise.all([__webpack_require__.e(277), __webpack_require__.e(565)]).then(() => (() => (__webpack_require__(28277))))));
			register("@amzn/katal-metrics-driver-sushi", "1.2.0", () => (Promise.all([__webpack_require__.e(234), __webpack_require__.e(275)]).then(() => (() => (__webpack_require__(30234))))));
			register("@amzn/katal-metrics", "2.1.1", () => (__webpack_require__.e(706).then(() => (() => (__webpack_require__(38706))))));
			register("@amzn/katal-metrics", "2.1.1", () => (Promise.all([__webpack_require__.e(989), __webpack_require__.e(541)]).then(() => (() => (__webpack_require__(95989))))));
			register("@amzn/wfm-lighthouse-hub-commons", "1.0.0", () => (() => (__webpack_require__(46123))), 1);
			register("date-fns-tz", "1.3.7", () => (__webpack_require__.e(722).then(() => (() => (__webpack_require__(70722))))));
			register("date-fns", "2.29.3", () => (__webpack_require__.e(857).then(() => (() => (__webpack_require__(7857))))));
			register("i18next-browser-languagedetector", "6.1.2", () => (__webpack_require__.e(886).then(() => (() => (__webpack_require__(70886))))));
			register("i18next-icu", "2.0.3", () => (__webpack_require__.e(759).then(() => (() => (__webpack_require__(36706))))));
			register("i18next-xhr-backend", "3.2.2", () => (__webpack_require__.e(346).then(() => (() => (__webpack_require__(22346))))));
			register("i18next", "19.9.2", () => (Promise.all([__webpack_require__.e(5), __webpack_require__.e(370)]).then(() => (() => (__webpack_require__(10005))))));
			register("intl-messageformat", "9.11.2", () => (__webpack_require__.e(15).then(() => (() => (__webpack_require__(94015))))));
			register("lodash", "4.17.21", () => (__webpack_require__.e(486).then(() => (() => (__webpack_require__(96486))))));
			register("react-dom", "16.14.0", () => (__webpack_require__.e(935).then(() => (() => (__webpack_require__(73935))))));
			register("react-i18next", "10.13.2", () => (__webpack_require__.e(804).then(() => (() => (__webpack_require__(90804))))));
			register("react-router-dom", "5.3.0", () => (Promise.all([__webpack_require__.e(382), __webpack_require__.e(337)]).then(() => (() => (__webpack_require__(77382))))));
			register("react", "16.14.0", () => (__webpack_require__.e(294).then(() => (() => (__webpack_require__(67294))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};